import { ApolloError, useQuery } from '@apollo/client'
import { AppraisalStatusModalQuery, AppraisalStatusModalQueryVariables, Country } from '../../../types'
import { APPRAISAL_STATUS_MODAL } from '../MeetingQueries'

export const useAppraisalStatusModal = (
  meetingId: string,
  employeeId: string,
  country: Country,
  isAppraisalUpdate = false,
): { data: AppraisalStatusModalQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, loading, error } = useQuery<AppraisalStatusModalQuery, AppraisalStatusModalQueryVariables>(APPRAISAL_STATUS_MODAL, {
    variables: {
      meetingId,
      employeeId,
      country,
      isAppraisalUpdate,
    },
    fetchPolicy: 'network-only',
  })

  return { data, loading, error }
}
